/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnalyticsSignalMetadata,
  AnalyticsSignalMetadata$inboundSchema,
} from "./analyticssignalmetadata.js";

export type AnalyticsSignalResult = {
  /**
   * Whole-window totals for selected groups; group_values follows metadata.group_by
   */
  groups: Array<{ [k: string]: any }>;
  metadata: AnalyticsSignalMetadata;
  /**
   * Exact whole-window measures, including groups outside the selected top groups
   */
  summary: { [k: string]: any };
};

/** @internal */
export const AnalyticsSignalResult$inboundSchema: z.ZodMiniType<
  AnalyticsSignalResult,
  unknown
> = z.object({
  groups: z.array(z.record(z.string(), z.any())),
  metadata: AnalyticsSignalMetadata$inboundSchema,
  summary: z.record(z.string(), z.any()),
});

export function analyticsSignalResultFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsSignalResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsSignalResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsSignalResult' from JSON`,
  );
}
